import * as React from 'react';
import { FC, useEffect } from 'react';

import { Header, Text } from '@rbilabs/universal-components';
import queryString from 'query-string';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { LayoutContainer } from 'components/layout/styled';
import Logo from 'components/logo';
import useAuth from 'hooks/auth/use-auth';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useAuthContext } from 'state/auth';
import { ModalAuthScreen } from 'state/auth/types';
import { portalToFooter } from 'state/mobile-footer';
import { portalToReplaceHeader } from 'state/mobile-header-nav';
import { routes } from 'utils/routing';

import { StyledActionButton, StyledBox, StyledLogo } from './styled';

export const WalmartLandingPage: FC<React.PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const { isAuthenticated } = useAuthContext();
  const { setModalAuthState, openSignInModal } = useAuth();
  const { navigate } = useNavigation();

  const queryParams = queryString.parse(location.search);
  const authzCode = queryParams.authz;

  useEffect(() => {
    return () => {
      // TODO: Consider closing the modal using state in the useAuth context on mount.
      setModalAuthState({ screen: ModalAuthScreen.CLOSED });
    };
  }, [setModalAuthState]);

  if (!authzCode) {
    navigate(routes.base);
    return null;
  }

  const HiddenAppHeader = portalToReplaceHeader(() => null);
  const HiddenAppFooter = portalToFooter(() => null);

  return (
    <LayoutContainer isFullContainer={true}>
      <StyledBox>
        <StyledLogo>
          <Logo padding="0" />
        </StyledLogo>
        <Header paddingTop="$4">Walmart+</Header>
        <Text>AuthZ: {queryParams.authz || 'Not found'}</Text>
        <StyledActionButton
          onPress={() => {
            if (!isAuthenticated) {
              openSignInModal();
            }
          }}
        >
          {formatMessage({ id: 'getMyOffers' })}
        </StyledActionButton>
      </StyledBox>
      <HiddenAppHeader />
      <HiddenAppFooter />
    </LayoutContainer>
  );
};
